import { toast } from 'sonner'

/**
 * Zentrale Toast-Helfer über `sonner` (BMC-`<Toaster/>` hängt global unter
 * `ConsoleProviders`). Ersetzt die frühere AntD-`message`-API im Admin-Scope
 * und in den geteilten Common-Komponenten. Dünne, typisierte Wrapper — bewusst
 * ohne eigene Optionen, damit die Aufrufstellen einheitlich bleiben.
 */
export function notifySuccess(message: string): void {
  toast.success(message)
}

export function notifyError(message: string): void {
  toast.error(message)
}

export function notifyWarning(message: string): void {
  toast.warning(message)
}
